import React,{useEffect,useState,useCallback} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../Config/Base';
import { Oval } from  'react-loader-spinner'
import _ from 'lodash'

const pageSize = 5;

const TcAddressmain=() =>{

    const[details, setDetails] =useState([])
   
    const[adddetail, setAdddetail] =useState([])
   
    const[delDetail, setdelDetail] =useState([])
    const[display, setDisplay] =useState(true)
  const[edit,setEdit]= useState(true)
  const[del,setDel]= useState(true)
  const[btn,setBtn]= useState(true)

  const [allusers,setAllusers]= useState([])
  const [paginatedPosts, setpaginatedPosts] = useState();
  
  const[pop,setpop] = useState(false);
  useEffect(()=>{
    addressget();
    setpop(true);
   
    document.getElementById('Tc-sectionMain').style.display ="none";
    document.getElementById('AddressTable').style.display ="none";
    document.getElementById('pagination').style.display ="none";

  

    setTimeout(()=>{
        setpop(false);
      document.getElementById('Tc-sectionMain').style.display ="flex";
      document.getElementById('AddressTable').style.display ="flex";
      document.getElementById('pagination').style.display ="block";
      getRoleData()
      //GetTcUserAllRole()     
      getUserRole();
    
    },1000)
    
  },[1])
 
  function addressget(){
   
    fetch('https://localhost:44312/Api/Tc/GetTcUserAddress', {
     
    method:'GET',
  
      headers : {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        //"Authorization": bearer,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
  
 //body:JSON.stringify(data)

}).then(response => response.json())
.then(data => {
console.log("Data",data)
  setDetails(data)
  setAllusers(data)
  setpaginatedPosts(_(data).slice(0).take(pageSize).value());
  localStorage.setItem("TcAddressData", JSON.stringify(data));
});

}


function handlechange(){
  
  var AddressInput = document.getElementById("addressInput").value
    var LocationInput =  document.getElementById("locationInput").value
    var EmailInput =  document.getElementById("emailInput").value
    const email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if(!AddressInput){
      document.getElementById('addressError').innerHTML = "Address Required"
    }
    else{
      document.getElementById('addressError').innerHTML = ""
    }
    if(!LocationInput){
      document.getElementById('locationError').innerHTML = "Location Required"
    }
    else{
      document.getElementById('locationError').innerHTML = ""
    }
    if(!EmailInput){
      document.getElementById('emailError').innerHTML = "email Required"
    }
    else if (email1.test( document.getElementById("emailInput").value)===false){
      document.getElementById('emailErrorA').innerHTML = "Not Valid Email"
      document.getElementById('emailError').innerHTML = ""
    }
    else{
      document.getElementById('emailErrorA').innerHTML = ""
}
}

function handleEditchange(){
  
  var AddressInput = document.getElementById("editInputA").value
    var LocationInput =  document.getElementById("editInputB").value
    var EmailInput =  document.getElementById("editInputC").value
    const email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if(!AddressInput){
      document.getElementById('popInputA').innerHTML = "Address Required"
    }
    else{
      document.getElementById('popInputA').innerHTML = ""
    }
    if(!LocationInput){
      document.getElementById('popInputB').innerHTML = "Location Required"
    }
    else{
      document.getElementById('popInputB').innerHTML = ""
    }
    if(!EmailInput){
      document.getElementById('popInputC').innerHTML = "email Required"
    }
    else if (email1.test( document.getElementById("editInputC").value)===false){
      document.getElementById('popInputD').innerHTML = "Not Valid Email"
      document.getElementById('popInputC').innerHTML = ""
    }
    else{
      document.getElementById('popInputD').innerHTML = ""
}
}

   function AddTcuserAddress(){

    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
   
    var AddressInput = document.getElementById("addressInput").value
    var LocationInput =  document.getElementById("locationInput").value
    var EmailInput =  document.getElementById("emailInput").value
    const email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if(!AddressInput){
      document.getElementById('addressError').innerHTML = "Address Required"
    }
    else{
      document.getElementById('addressError').innerHTML = ""
    }
    if(!LocationInput){
      document.getElementById('locationError').innerHTML = "Location Required"
    }
    else{
      document.getElementById('locationError').innerHTML = ""
    }
    if(!EmailInput){
      document.getElementById('emailError').innerHTML = "email Required"
    }
    else if (email1.test( document.getElementById("emailInput").value)===false){
      document.getElementById('emailErrorA').innerHTML = "Not Valid Email"
      document.getElementById('emailError').innerHTML = ""
    }
    else{
      document.getElementById('emailErrorA').innerHTML = ""
    

            const body ={

              address:AddressInput ,
              location: LocationInput,
              email:EmailInput,
              createdBy:"1234"

            }
             console.log(body)
              axios({
             
              method:"POST",
               //url: `${BASE_URL}/Tc/TcUserAddress`,
             url:"https://localhost:44312/Api/Tc/TcUserAddress",
             data:body,
             headers: {
             "Content-Type" : "application/json",
             'Authorization':bearer
             }
      
              })
              .then((response) =>{
              console.log(response.data);
             
              closeAddressForm()
              if(response.data.status=='Success'){
                document.getElementById('success-notify').style.display = "block"
                 setTimeout(()=>{
                   document.getElementById('success-notify').style.display = "none"
                 },1000)
              }
              //alert("Address Added Sucessfully ")
              addressget() 
              })
              .catch(error => {
                console.log(error);
               //alert(" Address Added Failed !")
               document.getElementById('error-notify').style.display = "block"
               setTimeout(()=>{
                 document.getElementById('error-notify').style.display = "none"
               },1000)
           
              })
          }
            } 
            
            function openAddressForm()
            {
      
            document.getElementById("tcaddForm").style.display = "block";
            
                 }
          // close ADD FORM function 
    function closeAddressForm()
    {
     
        document.getElementById("tcaddForm").style.display = "none";
       document.getElementById("Formreset").reset();
       document.getElementById('addressError').innerHTML = ""
       document.getElementById('locationError').innerHTML = ""
       document.getElementById('emailError').innerHTML = ""
       document.getElementById('emailErrorA').innerHTML = ""
     }


    



function getDetails(Id){

  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  
  document.getElementById("tcEditForm").style.display = "block";

 const body ={
  
  id:Id

 }
 console.log(body);


  axios({          
     method: "POST", 
     //url: `${BASE_URL}/Tc/EditSection`,      
     url: "https://localhost:44312/Api/Tc/EditTcUserAddress",
     data:body,
     headers: {             
       'Content-Type': 'application/json' , 
       'Authorization':bearer     
     }
   
   })
   .then((response) =>{
    console.log(response.data);
    setAdddetail(response.data)

     }) 
   
 
} 

function closeEditForm()

{

document.getElementById("tcEditForm").style.display = "none";
document.getElementById("EditForm").reset();
document.getElementById('popInputA').innerHTML = ""
document.getElementById('popInputB').innerHTML = ""
document.getElementById('popInputC').innerHTML = ""
document.getElementById('popInputD').innerHTML = ""
}

function updateAddress(Id){

  var InputA = document.getElementById("editInputA").value;
  var InputB = document.getElementById("editInputB").value;
  var InputC = document.getElementById("editInputC").value;

  const email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if(!InputA){
    document.getElementById('popInputA').innerHTML = "Address Required"
  }
  // else{
  //   document.getElementById('popInputA').innerHTML = ""
  // }
  else if(!InputB){
    document.getElementById('popInputB').innerHTML = "Location Required"
    document.getElementById('popInputA').innerHTML = ""
  }
  // else{
  //   document.getElementById('popInputB').innerHTML = ""
  // }
  else if(!InputC){
    document.getElementById('popInputC').innerHTML = "email Required"
    document.getElementById('popInputB').innerHTML = ""
  }
  else if (email1.test( document.getElementById("editInputC").value)===false){
    document.getElementById('popInputD').innerHTML = "Not Valid Email"
    document.getElementById('popInputC').innerHTML = ""
  }
  else{
    document.getElementById('popInputD').innerHTML = ""

   
  const body ={
  
    address:InputA,
    location:InputB,
    id:Id,
    editedBy:"" ,
    email:InputC
  
   }
   console.log(body);
  
   let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
    axios({          
       method: "POST", 
       //url: `${BASE_URL}/Tc/EditSection`,      
       url: "https://localhost:44312/Api/Tc/UpdateTcUserAddress",
       data:body,
       headers: {             
         'Content-Type': 'application/json' , 
         'Authorization':bearer     
       }
     
     })
     .then((response) =>{
      console.log(response.data);
      closeEditForm()
      if(response.data.status=='Success'){
        document.getElementById('edit-notify').style.display = "block"
         setTimeout(()=>{
           document.getElementById('edit-notify').style.display = "none"
         },1000)
      }
   //alert("Address Updated Sucessfully ")
      addressget();
     
       }) 
       .catch(error => {
        console.log(error);
       alert("Address Updated Failed !")
   
      })
    }
}

function delAddress(Id){
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
   
    const body ={
      id:Id
    }
     console.log(body)
      axios({
     
      method:"POST",
       //url: `${BASE_URL}/Tc/Sectiondelete`,
     url:"https://localhost:44312/Api/Tc/DeleteTcUserAddress",
     data:body,
     headers: {
     "Content-Type" : "application/json",
     'Authorization':bearer
     }
  
      })
      .then((response) =>{
      console.log(response.data);
      if(response.data.status=='Success'){
        document.getElementById('del-notify').style.display = "block"
         setTimeout(()=>{
           document.getElementById('del-notify').style.display = "none"
         },1000)
      }
      //alert("Address Deleted Sucessfully")
       document.getElementById("modalDeleteForm").style.display = "none";
      addressget();
             
      })
  }

  function ConfirmDelete(Id){

    document.getElementById("modalDeleteForm").style.display = "block";
    getdelDetails(Id)
  
  }

  function getdelDetails(Id){

    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
    
   
  
   const body ={
    
    id:Id
  
   }
   console.log(body);
  
  
    axios({          
       method: "POST", 
       //url: `${BASE_URL}/Tc/EditSection`,      
       url: "https://localhost:44312/Api/Tc/GetTcAddress",
       data:body,
       headers: {             
         'Content-Type': 'application/json' , 
         'Authorization':bearer     
       }
     
     })
     .then((response) =>{
      console.log(response.data);
      setdelDetail(response.data)
  
       }) 
  
  } 
  function closedelForm()
  {
     document.getElementById("modalDeleteForm").style.display = "none";
   
   }
  
  
  function Cancel() {
  document.getElementById("modalDeleteForm").style.display = "none";      
  
     }

     function getRoleData(){
        let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
        
       let UserRole =  localStorage.getItem("Role");
      
       const body ={
        
        role:UserRole
      
       }
       console.log(body);
      
      
        axios({          
           method: "POST", 
           //url: `${BASE_URL}/Tc/EditSection`,      
           url: "https://localhost:44312/Api/Tc/GetTcloginUserRole",
           data:body,
           headers: {             
             'Content-Type': 'application/json' , 
             'Authorization':bearer     
           }
         
         })
         .then((response) =>{
          console.log(response.data);
          localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));
          
           }) 
         
          }
    
          // function GetTcUserAllRole(){
          //   fetch('https://localhost:44312/Api/Tc/GetTcUserAllRole', {
          //     method:'GET',
          //     headers : {
        
          //       "Content-type": "application/json",
        
          //       "Accept": "application/json",
          
          //      // "Authorization": "Bearer " + `${token}`,
          
          //       "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
          //     },
        
          //     //body:JSON.stringify(data)
        
          //   })
          //    .then(response => response.json())
          //   .then(data => {
          //     console.log(data)         
          //     localStorage.setItem("RoleData", JSON.stringify(data));
            
          //   });
          // }
    
       function getUserRole(){
    
        /**----getroleAction---- */
    let Tcrole =  localStorage.getItem("loginUserRoleaction");
    let roledata =  JSON.parse(Tcrole);
    let role = roledata.map((e)=>e.roleAction);
    console.log(role);
    
    let roles = role.toString();
    let Add = roles.includes('Add')
    console.log(Add)
    
    let View = roles.includes('View')
    console.log(View)
    
    let Edit = roles.includes('Edit')
    console.log(Edit)
    
    let Delete = roles.includes('Delete')
    console.log(Delete)

    let empty = roles.includes('')
    console.log(empty)
    let roleid = localStorage.getItem('RoleId')
let id = roleid.includes('01')
console.log(id)
    
    /**----- Conditions--- **/
    if(id==true&&empty==true&&Add==false&&View==false&&Edit==false&&Delete==false)
 {
 setEdit(true);
 setDel(true);
 setDisplay(true); 
//  document.getElementById('ActionData').style.display ="block";
 document.getElementById('TCAboutusbtn').style.display ="block";
 document.getElementById('action-err').innerHTML = ''
 }

    if(id==false&&empty==true&&Add==false&&View==false&&Edit==false&&Delete==false)
    {
      setEdit(false);
      setDel(false);
      document.getElementById('TCAboutusbtn').style.display ="none";
      document.getElementById('AddressTable').style.display ="none";
  document.getElementById('pagination').style.display ="none";
  document.getElementById('action-err').innerHTML = 'No Task Assign'
    }
if(Add==true&&View==false&&Edit==true&&Delete==true){
  setEdit(true);
  setDel(true);
  setDisplay(true); 
  document.getElementById('TCAboutusbtn').style.display ="block";    
  document.getElementById('ContentAction').style.display ="block";
}
if(Add==false&&View==true&&Edit==true&&Delete==true){
  setEdit(true);
  setDel(true);
  setDisplay(true); 
  document.getElementById('TCAboutusbtn').style.display ="none";    
  document.getElementById('ContentAction').style.display ="block";
}
if(Add==true&&View==true&&Edit==true&&Delete==true){
  setEdit(true);
  setDel(true);
  setDisplay(true); 
  document.getElementById('TCAboutusbtn').style.display ="block";    
  document.getElementById('ContentAction').style.display ="block";
}
if(Add==true&&View==false&&Edit==true&&Delete==false){
  setDel(false);
  setEdit(true);
  document.getElementById('ContentAction').style.display ="block";
  setDisplay(true);  
  document.getElementById('TCAboutusbtn').style.display ="block";
}
if(Add==true&&View==false&&Edit==false&&Delete==true){
  setDel(true);
  setEdit(false);
  document.getElementById('ContentAction').style.display ="block";
  setDisplay(true);  
  document.getElementById('TCAboutusbtn').style.display ="block";
}
       
    if(Add==true&&View==false&&Edit==false&&Delete==false){ 
      document.getElementById('TCAboutusbtn').style.display ="block";
      document.getElementById('AddressTable').style.display ="none";
      document.getElementById('pagination').style.display ="none";
    }
      
    if( Add==false&&View==true&&Edit==false&&Delete==false){
      setDisplay(false);
      document.getElementById('TCAboutusbtn').style.display ="none";
       document.getElementById('ActionData').style.display ="none";

    }
   
    if( Add==false&&View==false&&Edit==true&&Delete==false){
      
      setDel(false); 
      document.getElementById('TCAboutusbtn').style.display ="none";
       }
       if( Add==false&&View==true&&Edit==true&&Delete==false){
        setEdit(true); 
        setDel(false); 
        document.getElementById('TCAboutusbtn').style.display ="none";
         }
  
       if( Add==false&&View==true&&Edit==false&&Delete==true){
        setEdit(false); 
        setDel(true); 
        document.getElementById('TCAboutusbtn').style.display ="none";
         }
      
       if( Add==false&&View==false&&Edit==false&&Delete==true){
        setEdit(false); 
        document.getElementById('TCAboutusbtn').style.display ="none";
       
         }
          
        
    if(Add==false&&View==false&&Edit==true&&Delete==true){
      setEdit(true);
      setDel(true);
      setDisplay(true); 
      document.getElementById('TCAboutusbtn').style.display ="none";
      document.getElementById('ContentAction').style.display ="block";
   }
   
   if(Add==true&&View==true&&Edit==false&&Delete==false){
    setEdit(false);
    setDel(false);
    setDisplay(false);  
    document.getElementById('TCAboutusbtn').style.display ="block";
 }
 if( Add==true&&View==true&&Edit==true&&Delete==false){
  setEdit(true); 
  setDel(false); 
  document.getElementById('TCAboutusbtn').style.display ="block";
   }
   if( Add==true&&View==true&&Edit==false&&Delete==true){
    setEdit(false); 
    setDel(true); 
    document.getElementById('TCAboutusbtn').style.display ="block";
     }

      }


      
      const LEFT_PAGE = "LEFT";
      const RIGHT_PAGE = "RIGHT";
      const range = (from, to, step = 1) => {
        let i = from;
        const range = [];
      
        while (i <= to) {
          range.push(i);
          i += step;
        }
      
        return range;
      };
      
      const [currentPage, setCurrentPage] = useState(1);
      
 let data =  localStorage.getItem("TcAddressData")
 let transdata =  JSON.parse(data);
      let NUM_OF_RECORDS = transdata.length;
      let LIMIT = 5;
      
      const onPageChanged = useCallback(
      
        (event, page) => {
          event.preventDefault();
          setCurrentPage(page);
        },
        [setCurrentPage]
        
      );
      
      
      const currentData = transdata.slice(
        (currentPage - 1) * LIMIT,
        (currentPage - 1) * LIMIT + LIMIT
      );
      
      const Paginations = (props) => {
        const {
          totalRecords,
          pageLimit,
          pageNeighbours,
          onPageChanged,
          currentPage
        } = props;
        const [totalPages, setTotalPages] = useState(0);
        useEffect(() => {
          setTotalPages(Math.ceil(totalRecords / pageLimit));
        }, [setTotalPages]);
      
        const fetchPageNumbers = () => {
          const totalNumbers = pageNeighbours * 2 + 3;
        
          const totalBlocks = totalNumbers + 2;
        
      
          if (totalPages > totalBlocks) {
            const startPage = Math.max(2, currentPage - pageNeighbours);
            const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
      
            let pages = range(startPage, endPage);
      
            const hasLeftSpill = startPage > 2;
            const hasRightSpill = totalPages - endPage > 1;
            const spillOffset = totalNumbers - (pages.length + 1);
      
            switch (true) {
              case hasLeftSpill && !hasRightSpill: {
                const extraPages = range(startPage - spillOffset, startPage - 1);
                pages = [LEFT_PAGE, ...extraPages, ...pages];
                break;
              }
              case hasLeftSpill && hasRightSpill:
              default: {
                pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
                break;
              }
            }
            return [1, ...pages, totalPages];
          }
          return range(1, totalPages);
        };
      
      
        const pages = fetchPageNumbers() || [];
        return (
          <nav aria-label="Countries Pagination">
            <ul className="pagination">
              {pages.map((page, index) => {
                if (page === LEFT_PAGE)
                  return (
                    <li key={index} className="page-item">
                      <a
                        href="/"
                        className="page-link"
                        aria-label="Previous"
                        onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                      >
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                  );
      
                if (page === RIGHT_PAGE)
                  return (
                    <li key={index} className="page-item">
                      <a
                        className="page-link"
                        href="/"
                        aria-label="Next"
                        onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 3)}
                      >
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  );
      
                return (
                  <li
                    key={index}
                    className={`Tc-page-item${currentPage === page ? " active" : ""}`}
                  >
                    <a
                      className="page-link"
                      href="/"
                      onClick={(e) => onPageChanged(e, page)}
                    >
                      {page}
                    </a>
                  </li>
                );
              })}
            </ul>
          </nav>
        );
      };
      
  return (
    <div className='TC-addmain'>  
     
<div className="TC-addgrid-layout">
<div className="TC-addmain-top">
<div className='TC-addmain-back'>
<Link to='/TcAboutus'><i className="fa-sharp fa-solid fa-backward"></i></Link>
</div> 
<span> Address </span>
</div>
</div>

<span id='action-err'></span>
<div  id='Tc-sectionMain'>

<button class="AddaboutusBtn" id='TCAboutusbtn'><span onClick={openAddressForm}><i className="fa-regular fa-square-plus"></i></span><span onClick={openAddressForm}>ADD </span></button>
 {/* <button onClick={openAddressForm} className='TCAboutusbtn' id='TCaddressbtn'><i className="fa-regular fa-square-plus"></i>&nbsp;&nbsp;ADD</button> */}
 </div>

 {/* ---  Add Form--- */}

<div className='TCpopfade' id="tcaddForm">
  <div className="modal-dialog" role="document">
    <div className="modal-content" id="modal-Popup">
      <div className="modal-header text-center">
      <h4 className="modal-title w-100 font-weight-bold">Add Address Details</h4>
        <button type="button" className="close"onClick={closeAddressForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
     
      <form id="Formreset">
              <div className="modal-body mx-3">
                  <div className="md-form mb-3">
                  <input id='addressInput' placeholder='Address' onKeyUp={handlechange}></input>
                  <span id='addressError' className='Tcadduser-error'></span>
                  </div>
                  <div className="md-form mb-3">
                  <input id='locationInput' placeholder='Location' onKeyUp={handlechange}></input>
                   <span id='locationError' className='Tcadduser-error'></span> 
                  </div>
                  <div className="md-form mb-3">
                  <input id='emailInput' placeholder='Email' onKeyUp={handlechange}></input>
                   <span id='emailError' className='Tcadduser-error'></span> 
                   <span id='emailErrorA' className='Tcadduser-error'></span> 
                  </div>
                </div>
                  <div className="modal-footer d-flex justify-content-center">
                        <button  className='TC-adduser-button' onClick={AddTcuserAddress}>Submit</button>
                  </div>
             </form>

    </div>
  </div>
</div>

<div className='TCpopfade' id='success-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Address&nbsp; <span style={{color:"blue"}}>Added</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
             
          </section> 
 
    </div>
  </div>
</div>

<div className='TCpopfade' id='error-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p>Address&nbsp; Added </p>
      <h6 class="notif-title">Failed !&nbsp;<i class="fa-solid fa-thumbs-down"style={{fontSize:'25px'}}></i></h6>
    
   </section>
    </div>
  </div>
</div>


<div className='TCpopfade' id='edit-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Address&nbsp; <span style={{color:"blue"}}>Updated</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          
          </section> 
            
          
    </div>

  </div>
</div>

<div className='TCpopfade' id='del-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Address&nbsp; <span style={{color:"red"}}>Deleted</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          </section> 
            
          
    </div>
  </div>
</div>

 {/* ---  Edit form--- */}

<form id="EditForm" >
<div className='TCpopfade' id="tcEditForm">
  <div className="modal-dialog" role="document">
    <div className="modal-content" id="modal-Popup">
      <div className="modal-header text-center">
      <h4 className="modal-title w-100 font-weight-bold" >Edit Address</h4>
        <button type="button" className="close"onClick={closeEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
     
      
      {adddetail.map((e)=>
{
return<div>
   <div className="modal-body mx-3">
                  <div className="md-form mb-3">
                    <label>Address</label>
                  <input id='editInputA'  defaultValue={e.address} onKeyUp={handleEditchange}/>
                  <span id="popInputA" className='Tcadduser-error'></span>
                  </div>
    
                   <div className="md-form mb-3">
                   <label>Location</label>
                   <input id="editInputB"   defaultValue={e.location} onKeyUp={handleEditchange}/> 
                   <span id="popInputB" className='Tcadduser-error'></span>              
                  </div>

                  <div className="md-form mb-3">
                  <label>Email</label>
                   <input id="editInputC"   defaultValue={e.email} onKeyUp={handleEditchange}/>
                   <span id="popInputC" className='Tcadduser-error'></span> 
                   <span id="popInputD" className='Tcadduser-error'></span>                 
                  </div>
                </div>

                  <div className="modal-footer d-flex justify-content-center">
                  <button className='TC-adduser-button' onClick={()=>updateAddress(e.id)}>Update</button>
      
                  </div>
 </div>
 }
 )}
           

    </div>
  </div>
</div>
</form>


 {/* --- Address table--- */}

<div className='TCtable' id="AddressTable">
     <div class="TC-aboutustable_responsive">
     {
  !paginatedPosts ? (<span style={{display:'flex',justifyContent:'center'}}>No Data Found</span>):(
       <table  className='TC-tblhead' id='TcTable'> 
    <thead>
   <tr>
<th>Address</th>
<th>Location</th>
<th>Email</th>
{display?<th>Action</th>:null}

</tr>
</thead>
<tbody>

{currentData.map((e,index)=>
{
 
return<tr id='row' key={index}>

<td>{e.address}</td>

<td>{e.location}</td>
<td>{e.email}</td>

{display?<td style={{whiteSpace:'nowrap'}}>{edit?<i id='Tcediticon' onClick={()=>getDetails(e.id)} className="fa-regular fa-pen-to-square"></i>:null}&nbsp;&nbsp;&nbsp;

{del?<i className="fa-solid fa-trash" id='Tcdelicon' onClick={()=>ConfirmDelete(e.id)}></i>:null}<span id='action-err'></span></td>:null}

</tr>

}
)}
</tbody>

</table>
)}

     </div> 
  </div>
  
  <br></br> <br></br>
  <div id='pagination'>
  {
  !paginatedPosts ? (""):(
  <nav id='Tc-Pag'>
   {transdata.length<=5 ? null:   <ul className='Tc-pagination'>
    <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={2}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          />
    </ul>}
  </nav>
  )}
  </div>

  <div className="TCpopfade" id="modalDeleteForm" tabindex="-1" role="dialog">
{delDetail.map((e)=>
{
return<div>
  <div className="modal-dialog" role="document">
    <div className="modal-contentA">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">Alert</h4>
        <button type="button" className="close" onClick={closedelForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>
   <div className="modal-body mx-3">

        <div className="md-form mb-3">
            <div className='text-center'>
          <h5>Are you sure want to&nbsp;<span style={{color:"red"}}>Delete?</span></h5>
       
          </div>
        </div>
   </div>

      <div className="modal-footer d-flex justify-content-center">
       <button className='TC-logout-button'onClick={()=>delAddress(e.id)}  type='submit'>Confirm</button>
        &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;<button className='TC-logout-button' onClick={Cancel} type='submit'>Cancel</button>
      </div>
      </form>
      
    </div>
  </div>
  </div>
  }
 )}
     </div>




{pop? <div id="Loader">
<Oval
  height={40}
  width={50}
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}


</div>
  )
}
export default  TcAddressmain